<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp flex o-d-main">
			<div class="o-d-l">
				<div class="back pointer" @click="goBack">
					<i class="el-icon-arrow-left"></i><span>售后详情</span>
				</div>
				<div class="state" v-if="data.status == 1">待处理</div>
				<div class="state" v-if="data.status == 2">已处理</div>
				<div class="state" v-if="data.status == 3">已驳回</div>
				<div class="jj" v-if="data.status == 3">
					驳回原因：{{data.reject_message}}
				</div>
				<div class="address">
					<div class="l">
						<i class="el-icon-location"></i>
					</div>
					<div class="r">
						<p><span>{{order_address.address_one}}</span><span>{{order_address.city}}</span><span>{{order_address.province}}</span><span>{{order_address.country}}</span>
						</p>
						<p><span>{{order_address.name}}</span><span>{{order_address.phone}}</span><span>{{order_address.email}}</span>
						</p>
					</div>
					<!-- <div class="sh sh1"><img src="@/assets/logo.png" alt="" /><span>审核中</span></div>
					<div class="sh sh1"><img src="@/assets/logo.png" alt="" /><span>审核驳回</span></div>
					<div class="sh sh2"><img src="@/assets/logo.png" alt="" /><span>审核通过</span></div>
					<div class="bh">查看驳回原因</div> -->
				</div>
				<div class="after-info">
					<p>售后类型：
						<span v-if="data.type == 0">-</span>
						<span v-if="data.type == 1">退货退款</span>
						<span v-if="data.type == 2">补发配件</span>
						<span v-if="data.type == 3">订单异常</span>
					</p>
					<p v-if="data.type == 1">退款金额：￥{{data.order.pay_price}}</p>

					<p v-if="data.type == 2">配件信息：<span v-for="(item,index) in reissue_arr"
							:key="index">{{item.sku_name_string}}×{{item.number}}、</span></p>
					<p>情况说明：{{data.explain}}</p>

					<div class="imgs">
						<div class="imgs-l">
							图片视频：
						</div>
						<div class="imgs-r flex">
							<div class="i" v-for="(item,index) in images" :key="index">
								<!-- <img src="@/assets/logo.png" alt="" /> -->


								<img src="@/assets/video.png" v-if="item.type === 'mp4'"
									style="width: 100%; height: 100%" @click="openFile(item.url)" />
								<el-image style="width: 100%; height: 100%" :src="item.url"
									:preview-src-list="[item.url]" v-else>
								</el-image>
							</div>
						</div>
					</div>
					<div class="imgs">
						<div class="imgs-l">
							文件：
						</div>
						<div class="imgs-r flex">
							<div class="i pointer" v-for="(item,index) in files" :key="index">
								<el-image style="width: 100%; height: 100%" class="img" :src="item.url"
									v-if="item.type === 'png'||item.type === 'jpg'||item.type === 'gif'"
									:preview-src-list="[item.url]">
								</el-image>

								<img src="@/assets/excel.png" class="img"
									v-if="item.type === 'xlsx'||item.type === 'xls'" @click="openFile(item.url)" />

								<img src="@/assets/word.png" class="img" v-if="item.type==='doc'||item.type === 'docx'"
									@click="openFile(item.url)" />

								<img src="@/assets/ppt.png" class="img" v-if="item.type===''||item.type === 'pptx'"
									@click="openFile(item.url)" />
								<img src="@/assets/pdf.png" class="img" v-if="item.type === 'pdf'"
									@click="openFile(item.url)" />
							</div>
						</div>
					</div>
				</div>
				<div class="hr"></div>
				<div class="gl flex pointer" @click="pageToOrder(data.order.id)">
					<div class="gl-l">
						关联订单 | {{data.order && data.order.order_number}}
					</div>
					<div class="gl-r flex">
						<!-- <span v-if="data.status == 1">待处理</span>
						<span v-if="data.status == 2">已处理</span>
						<span v-if="data.status == 3">已驳回</span> -->
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="o-d-goods">
					<div class="item1">
						<div class="i i1">商品</div>
						<div class="i i2">
							价格
						</div>
					</div>
					<div class="item" v-for="(item,index) in order_goods" :key="index"
						@click="toDetails(item.goods_id)">
						<div class="img">
							<img :src="http + item.goods_image" alt="" />
						</div>
						<div class="con">
							<div class="name">{{item.goods_title}}</div>
							<div class="p">{{item.warehouse_id}}</div>
							<div class="p">{{item.goods_child_sku_string}}</div>
						</div>
						<div class="price">
							<p>￥{{item.price}}</p>
							<p>x{{item.number}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="o-d-r">
				<div class="title">售后详情</div>
				<div class="list">
					<div class="item">
						<div class="l">售后单号</div>
						<div class="r flex">{{data.refund_order_number}}
							<img src="@/assets/copy.png" alt="" @click="copyText(data.refund_order_number)" />
						</div>
					</div>
					<div class="item">
						<div class="l">创建时间</div>
						<div class="r">
							{{$timeFormat(data.createtime,'yyyy-mm-dd hh:MM:ss')}}
						</div>
					</div>
					<div class="item" v-if="data.status > 1">
						<div class="l">审核时间</div>
						<div class="r">
							{{data.reject_time}}
						</div>
					</div>
					<div class="item" v-if="data.type == 1  && data.status == 2">
						<div class="l">运费承担</div>
						<div class="r">{{data.is_assume_logistics==1?'平台承担':'用户承担'}}</div>
					</div>
					<div class="item" v-if="data.type == 1 && data.status == 2">
						<div class="l">退款金额</div>
						<div class="r">￥<span style="font-weight: 600;" class="num-din">{{data.refund_price}}</span>
						</div>
					</div>
					<div class="item" v-if="data.type == 1 && data.status == 2">
						<div class="l">费用明细</div>
						<div class="r">
							<i v-for="(item,index) in fylist" :key="index">{{item.title}}￥{{item.price}}<template
									v-if="index<fylist.length-1">、</template></i>
						</div>
					</div>
					<div class="item" v-if="data.refund_images!=null  && data.status == 2">
						<div class="l">退款凭证</div>
						<div class="r" @click="seeShow = true">
							<span class="see">查看凭证</span>
							<!-- <el-image style="width: 30px; height: 30px" :src="require('@/assets/tk.png')"
								:preview-src-list="data.refund_images.split(',')">
							</el-image> -->
						</div>
					</div>
					<div class="item" v-if="data.remark" style="align-items: flex-start;">
						<div class="l" style="line-height: 24px;">平台备注</div>
						<div class="r" style="line-height: 24px;">{{data.remark}}</div>
					</div>


					<div class="item" v-if="data.type == 3 && data.reply_message" style="align-items: flex-start;">
						<div class="l" style="line-height: 24px;">审核意见</div>
						<div class="r" style="line-height: 24px;">{{data.reply_message}}</div>
					</div>
				</div>
				<div class="hr"></div>

				<template v-if="data.type == 2 && data.status == 2">

					<div class="title">发货信息</div>
					<div class="list" v-if="data && data.order">
						<div class="item">
							<div class="l">发货单号</div>
							<div class="r flex">{{data.logistics_number}}
								<img src="@/assets/copy.png" alt="" @click="copyText(data.logistics_number)" />
							</div>
						</div>
						<div class="item">
							<div class="l">快递公司</div>
							<div class="r">{{data.logistics_company}}</div>
						</div>
						<div class="item" v-if="data.logistics_images">
							<div class="l">快递面单</div>
							<div class="r" @click="seeImg(http + data.logistics_images)">
								<span class="see">查看</span>
								<!-- <el-image style="width: 30px; height: 30px" :src="require('@/assets/tk.png')"
								:preview-src-list="data.refund_images.split(',')">
							</el-image> -->
							</div>
						</div>

					</div>
					<div class="hr"></div>

				</template>
				<div class="title">订单信息</div>
				<div class="list" v-if="data && data.order && data.order_goods">
					<div class="item">
						<div class="l">系统订单</div>
						<div class="r flex">{{data.order.order_number}}
							<img src="@/assets/copy.png" alt="" @click="copyText(data.order.order_number)" />
						</div>
					</div>
					<div class="item">
						<div class="l">创建时间</div>
						<div class="r">{{$timeFormat(data.order.createtime,'yyyy-mm-dd hh:MM:ss')}}</div>
					</div>
					<div class="item">
						<div class="l">商品数量</div>
						<div class="r">共 <b class="num-din">{{data.order_goods.length}}</b>件</div>
					</div>
					<div class="item">
						<div class="l">商品总价</div>
						<div class="r">￥<span style="font-weight: 600;"
								class="num-din">{{getTotalPs(data.order)}}</span></div>
					</div>
					<div class="item">
						<div class="l">签名服务</div>
						<div class="r">￥<span style="font-weight: 600;" class="num-din">{{data.order.sign_price}}</span>
						</div>
					</div>
					<div class="item">
						<div class="l">订单价格</div>
						<div class="r">￥<span style="font-weight: 600;"
								class="num-din">{{data.order.is_new ==1 ? data.order.pay_price:0}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>

		<el-dialog title="" :visible.sync="seeShow" width="460px" close-on-click-modal close-on-press-escape center
			custom-class="see-pop" @close="closeSee">
			<div class="see-dialog">
				<div class="top" v-if="data.status == 1">
					<img src="@/assets/wite.png" alt="" />
					<p>退款中{{data.order.pay_price}}元</p>
				</div>
				<div class="top" v-if="data.status == 2">
					<img src="@/assets/over.png" alt="" />
					<p>已退款{{data.refund_price}}元 <span v-if="data.refund_images"
							@click="openFile(http + data.refund_images)">凭证</span></p>
				</div>
				<div class="footer">
					<div class="item flex">
						<div class="l">实际退款金额</div>
						<div class="r">{{data.status == 2?data.refund_price:'-'}}元</div>
					</div>
					<div class="item flex">
						<div class="l">申请退款金额</div>
						<div class="r">{{data.order.pay_price}}元</div>
					</div>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation
		},
		data() {
			return {
				seeShow: false,
				http: this.$imgUrl,
				list: [],
				pageSize: 0,
				page: 1,
				dialogImageUrl: '',
				dialogVisible: false,
				dialogShow: false,
				url: '',
				srcList: [],
				order_goods: [],
				order_address: {},
				images: [],
				files: [],
				data: {
					id: 0,
					order: {
						pay_price: 0
					}
				},
				reissue_arr: [],
				refund_images: [],
				fylist: []
			};
		},
		created() {
			this.id = this.$route.query.id
			this.getData();
		},
		computed: {
			getTotalPs() {
				return (data) => {
					let p = parseFloat(data.pay_price) - parseFloat(data.sign_price)
					return p.toFixed(2)
				}
			},
		},
		methods: {
			seeImg(img) {
				window.open(img, '_blank', 'noopener noreferrer');
			},
			closeSee() {
				this.seeShow = false
			},
			openFile(URL) {
				console.log(URL)
				window.open(URL, '_blank', 'noopener noreferrer');
			},
			pageToOrder(id) {
				this.$router.push({
					path: "/orderDetails",
					query: {
						id: id,
						operate: 'details'
					}
				});
			},
			goBack() {
				this.$router.go(-1);
			},
			getData() {

				this.$http.get('/api/order_refund/info', {
					params: {
						id: this.id
					}
				}).then(res => {
					console.log(res)
					this.data = res.data



					this.order_address = res.data.order_address
					this.order_goods = res.data.order_goods
					let images = res.data.explain_images ? res.data.explain_images.split(',') : []
					let files = res.data.explain_files ? res.data.explain_files.split(',') : []
					this.images = images.map(item => {
						return {
							url: this.http + item,
							type: item.split('.').slice(-1)[0]
						}
					})



					let refund_images = res.data.refund_images ? res.data.refund_images.split(',') : []
					this.refund_images = refund_images.map(item => this.http + item)
					this.files = files.map(item => {
						return {
							url: this.http + item,
							type: item.split('.').slice(-1)[0]
						}
					})
					console.log(this.files, 45454545)
					if (res.data.reissue_arr) {
						this.reissue_arr = JSON.parse(res.data.reissue_arr)
						console.log(this.reissue_arr, 'this.reissue_arr')
					}
					this.fylist = res.data.detail && JSON.parse(res.data.detail)
					console.log(this.fylist, 'this.fylist', this.data.order.pay_price, 222222222222)




				});

			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleRemove2(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/goodsDetails",
					query: {
						id: id
					}
				});
			},
			async copyText(data) {
				try {
					await navigator.clipboard.writeText(data);
					this.$message({
						type: 'success',
						message: '复制成功!'
					});
				} catch (err) {
					this.$message({
						message: '复制失败！你的的浏览器不支持自动复制,请手动复制!',
						type: 'warning'
					});

				}
			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;



	.see-dialog {
		.top {
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
			justify-content: center;
			padding-top: 30px;

			img {
				width: 60px;
				height: 60px;
			}

			p {
				height: 40px;
				line-height: 40px;
				font-size: 18px;
				color: #333;
				font-weight: 600;
				margin-top: 20px;

				span {
					font-size: 14px;
					color: #3572F5;
					text-decoration-line: underline;

					cursor: pointer;
					margin-left: 5px;
				}
			}

		}

		.footer {
			margin-top: 50px;
			background-color: #FAFAFA;

			.item {
				line-height: 50px;
				height: 50px;
				padding: 0 30px;
				font-size: 14px;
				color: #333;
				font-weight: 600;

				.l {
					width: 100px;
				}

				.r {
					flex: 1;
					text-align: right;
					width: 1px;
				}

			}
		}
	}

	.apply-pj-addr {
		margin-bottom: 10px;

		.pj {
			padding: 10px;
			background: #FFFFFF;
			border-radius: 6px 6px 6px 6px;
			border: 1px solid #D8D8D8;
			font-size: 14px;
			color: @color1;
			line-height: 30px;
			text-align: left;
		}

		.title {
			height: 40px;
			line-height: 40px;

			.l {
				text-align: left;
				font-size: 14px;
				color: @color1;
			}

			.r {
				flex: 1;
				width: 1px;
				display: flex;
				align-items: center;
				justify-content: flex-end;

				img {
					width: 14px;
					height: 14px;
				}

				span {
					color: @color2;
					font-size: 12px;
					margin-left: 5px;
				}
			}
		}
	}

	.jj {
		color: #FF2222;
		font-size: 14px;
		line-height: 30px;
		margin: 20px auto;
		border-bottom: 1px solid #eee;
		padding-bottom: 20px;
	}

	.after-info {
		padding: 10px;
		background: #F7F9FA;
		border-radius: 6px;
		margin: 20px auto;

		p {
			font-size: 14px;
			color: @color1;
			line-height: 24px;
			margin-bottom: 10px;
		}

		.imgs {
			display: flex;
			flex-direction: column;
			margin-bottom: 20px;

			.imgs-l {
				font-size: 14px;
				color: @color1;
				line-height: 24px;
				height: 24px;
			}

			.imgs-r {

				flex-wrap: wrap;
				margin-top: 10px;

				.i {
					width: 40px;
					height: 40px;
					border-radius: 4px;
					overflow: hidden;
					margin: 0 10px 10px 0;

					img {
						width: 100%;
						height: 100%;
					}

					video {
						width: 100%;
						height: 100%;
					}

				}
			}

		}
	}

	.state {

		height: 40px;
		line-height: 40px;
		font-weight: 800;
		font-size: 28px;
		color: #FF6A00;
		text-align: left;
		margin-top: 20px;
	}

	.dialog-footer2 {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.l {
			font-size: 14px;
			color: #868E99;

			span {
				color: @color1;
				margin-left: 5px;
			}
		}
	}

	.addpj {
		max-height: 560px;
		overflow-y: auto;

		.title {
			font-size: 14px;
			color: @color1;
			height: 32px;
			line-height: 32px;
			background: #F7F9FA;
			border-radius: 6px 6px 6px 6px;

			.i {
				text-align: left;
				text-indent: 10px;
			}

			.i1 {
				flex: 1;
				width: 1px;
			}

			.i2 {
				width: 100px;
			}
		}

		.item {
			padding: 10px 0;
			border-bottom: 1px solid #eee;

			.l {
				flex: 1;
				width: 1px;

				img {
					width: 40px;
					height: 40px;
					background: #FFFFFF;
					border-radius: 6px 6px 6px 6px;
					border: 1px solid #D8D8D8;
				}

				.con {
					flex: 1;
					width: 1px;
					margin-left: 10px;

					.name {
						height: 20px;
						line-height: 20px;
						font-size: 14px;
						color: @color1;
						text-align: left;
					}

					.info {
						height: 20px;
						line-height: 20px;
						font-size: 12px;
						color: #868E99;
						text-align: left;

					}
				}
			}

			.r {}
		}

	}

	.o-d-main {
		margin: 20px auto;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		border-radius: 10px;
		align-items: flex-start;
		justify-content: space-between;

		.o-d-l {
			flex: 1;
			width: 1px;
			margin-right: 20px;

			.apply-pj-addr {
				.pj {
					padding: 10px;
					background: #FFFFFF;
					border-radius: 6px 6px 6px 6px;
					border: 1px solid #D8D8D8;
					font-size: 14px;
					color: @color1;
					line-height: 30px;
					text-align: left;
				}

				.title {
					height: 40px;
					line-height: 40px;

					.l {
						text-align: left;
						font-size: 14px;
						color: @color1;
					}

					.r {
						flex: 1;
						width: 1px;
						display: flex;
						align-items: center;
						justify-content: flex-end;

						img {
							width: 14px;
							height: 14px;
						}

						span {
							color: @color2;
							font-size: 12px;
							margin-left: 5px;
						}
					}
				}
			}

			.apply-uploads {
				.item {
					padding: 10px 0;

					.title {
						text-align: left;
						font-size: 14px;
						color: @color1;
						height: 40px;
						line-height: 40px;

						span {
							font-size: 12px;
							color: #A9A9A9;
							margin-left: 10px;
						}
					}

					.textarea {}

					.hwk-upload {
						display: flex;
						align-items: center;

					}
				}
			}

			.apply-type {
				// margin-top: 20px;
				height: 40px;
				line-height: 40px;
				align-items: center;
				justify-content: space-between;

				.l {
					font-size: 14px;
					color: @color1;
					flex: 1;
					text-align: left;
				}

				.r {
					align-items: center;
					justify-content: flex-end;
					flex: 1;
					display: flex;

					.i {
						flex: 1;

						img {
							width: 15px;
							height: 15px;
							align-items: center;
							margin-right: 5px;
						}

						span {
							font-size: 14px;
							color: #3F3F3F;
						}
					}
				}
			}

			.gl {
				align-items: center;
				justify-content: space-between;
				height: 36px;
				line-height: 36px;
				background: #FFF5EE;
				border-radius: 6px;
				padding: 0 10px;
				box-sizing: border-box;

				.gl-l {
					text-align: left;
					font-size: 14px;
					color: @color1;
				}

				.gl-r {
					text-align: center;

					span {
						font-size: 14px;
						color: @color2;
						margin-right: 5px;
					}

					i {
						color: @color2;
					}
				}
			}

			.o-hd {
				display: flex;
				align-items: center;
				height: 30px;
				line-height: 30px;
				margin-top: 10px;

				img {
					width: 16px;
					height: 16px;
				}

				p {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: #3572F5;
						text-decoration-line: underline;
						margin-left: 10px;
					}
				}

			}

			.o-d-goods {
				margin-top: 20px;

				.item {
					padding: 10px 0;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.price {
						width: 100px;

						p {
							font-size: 14px;
							color: @color1;
							text-align: left;
							line-height: 20px;
						}
					}

					.img {
						width: 50px;
						height: 50px;
						background: #FFFFFF;
						border-radius: 6px 6px 6px 6px;
						border: 1px solid #D8D8D8;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.con {
						flex: 1;
						width: 1px;
						margin-left: 10px;

						.name {

							font-weight: 500;
							font-size: 14px;
							color: @color1;
							line-height: 20px;
							text-align: left;

						}

						.p {
							font-size: 12px;
							color: #50607A;
							line-height: 20px;
							text-align: left;
						}
					}
				}

				.item1 {
					height: 40px;
					line-height: 40px;
					background-color: #F7F9FA;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.i {
						font-size: 14px;
						color: @color1;
						text-align: left;
						text-indent: 10px;
					}

					.i1 {
						flex: 1;
						width: 1px;
					}

					.i2 {
						width: 100px;
					}
				}
			}

			.o-d-title {
				font-weight: bold;
				font-size: 16px;
				color: #11192D;
				height: 30px;
				line-height: 30px;
				text-align: left;
			}

			.o-d-list {
				font-size: 14px;

				.i {
					color: #868E99;
					height: 30px;
					line-height: 30px;
					margin-right: 20px;

					span {
						color: @color1;
					}
				}
			}

			.hr {
				margin: 20px auto;
				width: 100%;
				height: 1px;
				background-color: #eee;
			}

			.btns {
				.btn {
					width: 90px;
					height: 34px;
					line-height: 34px;
					font-size: 14px;
					border-radius: 10px 10px 10px 10px;
					text-align: center;

				}

				.btn1 {
					background-color: @color2;
					color: #fff;
				}

				.btn2 {
					background: #FFFFFF;
					border: 1px solid #D8D8D8;
					margin-left: 10px;
				}
			}

			.address {
				margin-top: 20px;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				position: relative;

				// border: 1px solid #D8D8D8;
				// padding: 20px;
				// border-radius: 6px;

				.bh {
					position: absolute;
					right: 10px;
					top: 45px;
					width: 100px;
					height: 24px;
					line-height: 24px;
					font-weight: 500;
					font-size: 12px;
					color: #3572F5;
					text-align: right;
					text-decoration-line: underline;
				}

				.sh {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 10px;
					top: 5px;
					padding: 0 10px;
					height: 22px;
					line-height: 22px;
					text-align: center;
					border-radius: 11px;

					img {
						width: 15px;
						height: 15px;
						margin-right: 5px;
					}

					span {
						font-size: 12px;

					}
				}

				.sh1 {
					background: #FFE5E5;

					span {
						color: #FF1717;
					}
				}

				.sh2 {
					background: #EEFFF1;

					span {
						color: #34C759;
					}
				}

				.l {
					i {
						font-size: 24px;
						color: @color2;
					}
				}

				.r {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					text-align: left;

					p {
						font-size: 14px;
						color: @color1;
						line-height: 24px;

						span {
							margin-right: 20px;
						}
					}
				}
			}

			.state {

				height: 40px;
				line-height: 40px;
				font-weight: 800;
				font-size: 28px;
				color: #FF6A00;
				text-align: left;
				margin-top: 20px;
			}

			.back {
				height: 30px;
				line-height: 30px;
				text-align: left;

				span {
					font-size: 16px;
					color: #11192D;
					margin-left: 5px;
				}

				&:hover {
					i {
						color: @color2;
					}

					span {
						color: @color2;
					}
				}
			}
		}

		.o-d-r {
			width: 370px;

			background: #FFFFFF;
			border-radius: 10px;
			border: 1px solid #EBEBEB;
			padding: 20px;
			box-sizing: border-box;

			.r-btns {
				align-items: center;
				justify-content: space-between;
				margin: 20px auto;
				text-align: center;

				.btn1 {
					width: 62px;
					height: 48px;
					line-height: 48px;
					background: #FFFFFF;
					border-radius: 10px 10px 10px 10px;
					border: 1px solid #D8D8D8;
					color: #868E99;
					font-size: 16px;
				}

				.btn2 {
					width: 248px;
					height: 48px;
					line-height: 48px;
					background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
					border-radius: 10px;
					opacity: 0.5;
					color: #fff;
					font-size: 16px;

				}
			}

			.title {

				height: 30px;
				line-height: 30px;
				font-weight: bold;
				font-size: 18px;
				color: @color1;
				text-align: left;
			}

			.hr {
				margin: 10px auto;
				width: 100%;
				height: 1px;
				background-color: #eee;
			}

			.list {
				margin-top: 10px;

				.item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					// height: 30px;

					line-height: 34px;

					.l {
						text-align: left;
						font-size: 14px;
						color: #868E99;
					}

					.r {
						flex: 1;
						width: 1px;
						text-align: right;
						font-size: 14px;
						color: @color1;
						align-items: center;
						justify-content: flex-end;

						span {
							font-size: 16px;
							font-weight: 600;
						}

						i {
							font-style: normal;
						}

						.see {

							font-size: 14px;
							color: #3572F5;
							text-align: right;
							text-decoration-line: underline;

							cursor: pointer;

						}

						img {
							width: 15px;
							height: 15px;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}
</style>